// @ts-strict-ignore
import type { ActionContext } from 'vuex'

import type { ActionClass } from '../../../models'

import { COMMON_CONSTS } from '../common.consts'

export class ResetAction implements ActionClass {
  static execute(this: void, { commit }: ActionContext<any, any>, initialState): void {
    commit(COMMON_CONSTS.mutations.reset, initialState)
  }
}
